module.exports = __webpack_public_path__ + "img/move17.00f5824c.jpg";